<template>
  <div class="p-3">
    <b-form>
      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-truck mr-2"></i> CONFIGURAÇÕES DE FRETE
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="4">
              <b-form-group label="Modalidade do Frete" class="premium-form-group mb-0">
                <b-form-select v-model="nfe.OP_MODALIDADE_FRETE" :options="modalidadeOptions" class="rounded-pill" @change="emitChanged" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-tabs nav-class="nav-pills-premium mb-3" content-class="mt-3">
        <b-tab active>
          <template #title>
            <i class="fa fa-id-card mr-1"></i> Transportador
          </template>
          <nfe-transp-transporte :nfe="nfe" :is-loading-from-backend="isLoadingFromBackend" :pode-editar="podeEditar" @changed="emitChanged" />
        </b-tab>
        <b-tab>
          <template #title>
            <i class="fa fa-car mr-1"></i> Veículo
          </template>
          <nfe-transp-veiculo v-model="transporte.veiculo" :pode-editar="podeEditar" @changed="emitChanged" />
        </b-tab>
        <b-tab>
          <template #title>
            <i class="fa fa-cubes mr-1"></i> Volumes
          </template>
          <nfe-transp-volumes :nfeId="nfe.ID" :canEdit="podeEditar" @changed="emitChanged" />
        </b-tab>
        <b-tab>
          <template #title>
            <i class="fa fa-ellipsis-h mr-1"></i> Diversos
          </template>
          <nfe-transp-diversos v-model="transporte.exportacao" :pode-editar="podeEditar" @changed="emitChanged" />
        </b-tab>
      </b-tabs>
    </b-form>
  </div>
</template>

<script>
import NfeTranspTransporte from './NfeTranspTransporte.vue'
import NfeTranspVeiculo from './NfeTranspVeiculo.vue'
import NfeTranspVolumes from './NfeTranspVolumes.vue'
import NfeTranspDiversos from './NfeTranspDiversos.vue'

export default {
  name: 'NfeAbaTransporte',
  components: { NfeTranspTransporte, NfeTranspVeiculo, NfeTranspVolumes, NfeTranspDiversos },
  props: {
    nfe: { type: Object, required: true },
    isLoadingFromBackend: { type: Boolean, default: false },
    podeEditar: { type: Boolean, default: false }
  },
  data() {
    return {
      modalidadeOptions: [
        // origem: contexto/units delphi/Unt_NotaFiscalEletronica.dfm
        { value: '0', text: '0 - Emitente' },
        { value: '1', text: '1 - Destinatário' },
        { value: '2', text: '2 - Terceiros' },
        { value: '9', text: '9 - Sem frete' }
      ]
    }
  },
  computed: {
    transporte() {
      // ensure nested object exists so bindings don't break
      if (!this.nfe.transporte) this.$set(this.nfe, 'transporte', { modalidade: '0', transportador: {}, veiculo: {}, volumes: [], exportacao: {} })
      return this.nfe.transporte
    }
  },
  created() {
    // created: transport tab initialization (debug logs removed)
  },
  methods: {
    emitChanged() {
      this.$emit('changed')
    }
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeAbaTransporte.vue